import { Attachment } from "./attachments";
import { DriverEntity, DutyStatus } from "./drivers";
import { OrderSideBarEntity } from "./orderSidebarEntity";
import { OrderTimeline } from "./orderTimelines";
import { Order } from "./orders";
import { RouteTimeline } from "./routeTimelines";
import "./routes";
import { Route, RoutePolylineType } from "./routes";
import { User } from "./users";

export * from "./analytics";
export * from "./apps";
export * from "./costOptimizer";
export * from "./customFieldGroups";
export * from "./customFields";
export * from "./dispatchLogics";
export * from "./doordash";
export * from "./drivers";
export * from "./expedite";
export * from "./externalServiceAssignee";
export * from "./featureflags";
export * from "./google";
export * from "./notification";
export * from "./notificationV2";
export * from "./onfleet";
export * from "./orderMetadata";
export * from "./orders";
export * from "./reports";
export * from "./roadie";
export * from "./routePolyline";
export * from "./routes";
export * from "./savedAddress";
export * from "./states";
export * from "./timezone";
export * from "./uber";
export * from "./users";
export * from "./workspaces";

export { type Attachment, type OrderTimeline, type RouteTimeline };

export type Base = {
  createdAt: Date;
  deletedAt: Date;
  id: string;
  updatedAt: Date;
};

export enum UserRole {
  ADMIN = "ADMIN",
  DISPATCHER = "DISPATCHER",
  BEAST = "BEAST",
  MEMBER = "MEMBER",
  DRIVER = "DRIVER",
  MANAGER = "MANAGER",
}

export enum TransportType {
  Bicycle = "BICYCLE",
  "Box Truck" = "BOX_TRUCK",
  "E-bike" = "E-BIKE",
  "E-scooter" = "E-SCOOTER",
  Motorcycle = "MOTORCYCLE",
  Other = "OTHER",
  "Pickup Truck" = "PICKUP_TRUCK",
  Sedan = "SEDAN",
  SUV = "SUV",
  "Sprinter Van" = "SPRINTER_VAN",
  Walking = "WALKING",
}

export type AppFilterType = {
  assigneeIds: string[];
  countryCode: string;
  driverStatus: DutyStatus[];
  orderDeliveryType: Order["type"][];
  orderStatus: Order["status"][];
  scheduledDateTimeEnd: string;
  scheduledDateTimeStart: string;
  stateIds: string[];
  workspaceIds: string[];
};

export enum TableHeadersName {
  ActualDropOffTime = "Actual Drop-off Time",
  ActualPickupTime = "Actual Pickup Time",
  Assignee = "Assignee",
  Connections = "Connections",
  DeliveryType = "Delivery Type",
  Description = "Description",
  EstimatedDistance = "Estimated Distance (Miles)",
  ActualDistance = "Actual Distance (Miles)",
  DropoffAddress = "Drop-off Address",
  DropoffArrivalTime = "Drop-off Arrival Time",
  DropoffCity = "Dropoff City",
  DropoffCountry = "Dropoff Country",
  DropoffState = "Dropoff State",
  ExternalId = "External ID",
  InTransit = "In Transit",
  ItemsCount = "Item Count",
  NotesRequirement = "Notes Requirement",
  OrderId = "Order ID",
  OrderInternalId = "Order Internal ID",
  OrderSourceId = "Order Source ID",
  PickupAddress = "Pickup Address",
  PickupArrivalTime = "Pickup Arrival Time",
  PickupCity = "Pickup City",
  PickupCountry = "Pickup Country",
  PickupName = "Pickup Name",
  PickupNote = "Pickup Note",
  PickupBusinessName = "Pickup Business Name",
  PickupPhone = "Pickup Phone",
  PickupState = "Pickup State",
  Priority = "Priority",
  POD = "POD",
  ProofOfDeliveryRequirement = "Proof of Delivery Requirement",
  RecipientName = "Recipient Name",
  RecipientNote = "Recipient Note",
  RecipientPhone = "Recipient Phone",
  RecipientBusinessName = "Recipient Business Name",
  ScheduledEndTime = "Scheduled End Time",
  ScheduledStartTime = "Scheduled Start Time",
  ServiceTime = "Service Time",
  SignatureRequirement = "Signature Requirement",
  Status = "Status",
  DriverNote = "Driver's Note",
  StatusReason = "Status Reason",
  Tip = "Tip",
  Value = "Value",
  VehicleType = "Vehicle Type",
  PickupWindow = "Scheduled Pickup Window",
  DropoffWindow = "Scheduled Drop-off Window",
  Timezone = "Timezone",
  ETAAtCreation = "ETA at Creation",
  Length = "Length (cm)",
  Width = "Width (cm)",
  Height = "Height (cm)",
  Weight = "Weight (gm)",
}

export {
  DutyStatus,
  type DriverEntity,
  type Order,
  type OrderSideBarEntity,
  type Route,
  type RoutePolylineType,
  type User,
};
